import InivatorImg_1 from '../img/jury/inovator_img_1.jpg'
import InivatorImg_2 from '../img/jury/inovator_img_2.jpg'
import InivatorImg_3 from '../img/jury/inovator_img_3.jpg'
import InivatorImg_4 from '../img/jury/inovator_img_4.jpg'
import MedicImg_1 from '../img/jury/medic_img_1.jpg'
import MedicImg_2 from '../img/jury/medic_img_2.jpg'
import MedicImg_3 from '../img/jury/medic_img_3.jpg'
import MedicImg_4 from '../img/jury/medic_img_4.jpg'
import MasterImg_1 from '../img/jury/master_img_1.jpg'
import MasterImg_2 from '../img/jury/master_img_2.jpg'
import MasterImg_3 from '../img/jury/master_img_3.jpg'
import MasterImg_4 from '../img/jury/master_img_4.jpg'
import YearImg_1 from '../img/jury/year_img_1.jpg'
import YearImg_2 from '../img/jury/year_img_2.jpg'
import YearImg_3 from '../img/jury/year_img_3.jpg'
import YearImg_4 from '../img/jury/year_img_4.jpg'
import MakeUpImg_1 from '../img/jury/makeup_img_1.jpg'
import MakeUpImg_2 from '../img/jury/makeup_img_2.jpg'
import MakeUpImg_3 from '../img/jury/makeup_img_3.jpg'
import MakeUpImg_4 from '../img/jury/makeup_img_4.jpg'
import BarberImg_1 from '../img/jury/barber_img_1.jpg'
import BarberImg_2 from '../img/jury/barber_img_2.jpg'
import BarberImg_3 from '../img/jury/barber_img_3.jpg'
import BarberImg_4 from '../img/jury/barber_img_4.jpg'
import GrowthImg_1 from '../img/jury/growth_img_1.jpg'
import GrowthImg_2 from '../img/jury/growth_img_2.jpg'
import GrowthImg_3 from '../img/jury/growth_img_3.jpg'
import GrowthImg_4 from '../img/jury/growth_img_4.jpg'
import VisagisteImg_1 from '../img/jury/visagiste_img_1.jpg'
import VisagisteImg_2 from '../img/jury/visagiste_img_2.jpg'
import VisagisteImg_3 from '../img/jury/visagiste_img_3.jpg'
import VisagisteImg_4 from '../img/jury/visagiste_img_4.jpg'

const data = [
    {
      year: 2023,
      items: [
        {
          title: 'Инноватор Года',
          name: 'Дмитрий Иванов (Председатель жюри)',
          text: 'Специалист по экологически чистым технологиям в косметике. Дмитрий на протяжении многих лет занимается разработкой и внедрением продуктов, которые не только эффективны, но и безопасны для окружающей среды. Он создал несколько новаторских формул, которые полностью биоразлагаемы и не содержат вредных химических веществ. Дмитрий активно промотирует концепцию устойчивого развития в косметической индустрии, ведя пример того, как компании могут сократить свое экологическое воздействие без ущерба для качества своих продуктов.',
          image: InivatorImg_1,
          name1: 'Елена Борисова (Беларусь)',
          name2: 'Артем Сидоров (Украина)',
          name3: 'Кирилл Ткачев (Казахстан)',
        },
        {
          title: 'Лучший Мастер Эстетической Медицины',
          name: 'Константин Фигловский (Председатель жюри)',
          text: 'Врач-косметолог, преподаватель косметологии, косметический технолог, руководитель и эксперт УЦ Аюна, главный косметолог сети студий красоты DPSP Epilier, лучший преподаватель аппаратных методик DORE AWARD 2020, лауреат Х международного конкурса косметологии и эстетики в номинации «Уход за кожей лица». Стаж работы в косметологии более 13 лет, г. Санкт-Петербург',
          image: MedicImg_1,
          name1: 'Ольга Пономарёва (Украина)',
          name2: 'Алиса Сергеева (Россия)',
          name3: 'Ирина Белоусова (Казахстан)',
        },
        {
            title: 'Мастер года в Ногтевой Эстетике',
            name: 'Алла Мустафина (Председатель жюри)',
            text: 'Международный судья, Многократный чемпион международных чемпионатов, Тренер международной категории, Спикер форумов nail индустрии,Основатель школы ногтевого сервиса "Ведьмин домик",Обладатель наград "Лучший тренер", "Лучшая команда", премии "Золотой Демиург" 2022 СРПИК,Соорганизатор Международного чемпионата по аэрографии "Воздушная Симфония". Разработчик техники по аэрографии.',
            image: MasterImg_1,
            name1: 'Алексадра Швец (Россия)',
            name2: 'Ольга Лунина (Украина)',
            name3: 'Анна Куликова (Казахстан)',
        },
        {
          title: 'Визажист Года',
          name: 'Игорь Белкин (Председатель жюри)',
          text: 'Пионер в области цифрового макияжа и использования AR/VR технологий в индустрии красоты. Игорь разработал ряд приложений и программ, которые позволяют виртуально примерять образы, что революционизировало подход к макияжу и обучению визажистов. Его инновации активно используются в ведущих школах макияжа по всему миру.',
          image: VisagisteImg_1,
          name1: 'Ольга Баранова (Беларусь)',
          name2: 'Дмитрий Савченко (Украина)',
          name3: 'Жанна Касымова (Казахстан)',
      },
        {
            title: 'Прорыв Года',
            name: 'Екатерина Романова (Председатель жюри)',
            text: 'Доктор наук в области биохимии, разработала серию органических составов для ухода за кожей, которые получили широкое признание за инновационный подход и высокую эффективность.',
            image: YearImg_1,
            name1: 'Максим Ковалев (Беларусь)',
            name2: 'Ирина Захарова (Украина)',
            name3: 'Даниил Сергеев (Казахстан)',
        },
        {
            title: 'Мастер года в Перманентном Макияже',
            name: 'Оксана Стасевич (Председатель жюри)',
            text: 'Тренер/Преподаватель - бровист, Эксперт - судья премии Melagarna awards, Многократный Международный чемпион по ламинированию и окрашиванию бровей, Лауреат премии «Преподаватель NUMBER ONE авторских BROW курсов» при поддержке министерства образования, Организатор @klukva.beauty.coach Лауреат международной премии «Beauty pro awards» в номинации ТОП10 «Brow Stylist», Эксперт - судья премии Melagarna awards в сфере оформления бровей',
            image: MakeUpImg_1,
            name1: 'Максим Самохин (Беларусь)',
            name2: 'Ольга Захарова (Украина)',
            name3: 'Анна Левчук (Казахстан)',
        },
        {
            title: 'Парикмахер Года',
            name: 'Екатерина Шусть (Председатель жюри)',
            text: 'Судья, тренер и партнер Чемпионата Beauty Olymp, Победитель Премии Top 10 brow expert 2022 при поддержке министерства образования РФ, Тренер бровистов с правом присваивать квалификацию «Мастер-бровист» с выдачей госдиплома установленного образца, Судья международного онлайн-чемпионата Brilliance 5 сезона, Партнер школы Flario (г. Москва), Серебро в бровях в Brilliance 3 сезона.',
            image: BarberImg_1,
            name1: 'Елена Михайлова (Беларусь)',
            name2: 'Ольга Захарова (Украина)',
            name3: 'Яна Козлова (Казахстан)',
        },
        {
            title: 'За Вклад в Развитие Индустрии',
            name: 'Михаил Кузнецов (Председатель жюри)',
            text: 'Пионер в области нанотехнологий, применяемых для создания косметики нового поколения. Михаил разработал несколько ключевых инноваций, которые сделали продукты более безопасными и эффективными, при этом сократив воздействие на окружающую среду.',
            image: GrowthImg_1,
            name1: 'Александр Морозов (Беларусь)',
            name2: 'Наталья Петрова (Украина)',
            name3: 'Тимур Сулейманов (Казахстан)',
        },

      ],
    },
    {
        year: 2022,
        items: [
          {
            title: 'Инноватор Года',
            name: 'Сергей Алексеев (Председатель жюри)',
            text: 'Известный разработчик умных устройств для косметологии. Сергей стал пионером в создании интегрированных систем, которые помогают косметологам улучшать качество своих услуг через автоматизированное оборудование и программное обеспечение. Его разработки включают устройства для анализа кожи, которые используют искусственный интеллект для точной диагностики и персонализированных рекомендаций. Сергей активно сотрудничает с косметическими клиниками по всему миру, обеспечивая внедрение инноваций, которые меняют подходы в индустрии красоты.',
            image: InivatorImg_2,
            name1: 'Татьяна Романова (Беларусь)',
            name2: 'Олег Кузьмин (Украина)',
            name3: 'Наталья Васильева (Казахстан)',
          },
          {
            title: 'Лучший Мастер Эстетической Медицины',
            name: 'Ирина Турухина (Председатель жюри)',
            text: 'Косметолог, специалист по «естественному омоложению», тренер-преподаватель по косметологии, бренд-менеджер центра развития и повышения квалификации косметологов на базе официального представительства профессиональной косметики LACRIMA в городе Санкт-Петербург, обладатель премии в области депиляции «Тренер года 2019», автор онлайн-курса “Секреты молодости». Стаж работы в косметологии более 12 лет. г. Санкт-Петербург.',
            image: MedicImg_2,
            name1: 'Алексей Жуков (Украина)',
            name2: 'Наталья Степанова (Россия)',
            name3: 'Анна Петрова (Казахстан)',
          },
          {
            title: 'Мастер года в Ногтевой Эстетике',
            name: 'Анна Карпова (Председатель жюри)',
            text: 'Мастер маникюра и педикюра, Многократный Победитель и призер Международных Чемпионатов, Чемпион России и Мира, Официальный инструктор SMART, Лауреат премии "Queen of Beauty", Лучший мастер по моделированию ногтей, Лауреат премии "DORE AWARDS" Топ - 50 Лучший Smart master, Партнёр и судья союза ЭСБИ, Руководитель и тренер команды "Anabell Neil Art".',
            image: MasterImg_2,
            name1: 'Екатерина Бунина (Россия)',
            name2: 'Мария Воронцова (Украина)',
            name3: 'Лариса Иванова (Казахстан)',
          },
          {
            title: 'Визажист Года',
            name: 'Елена Романова (Председатель жюри)',
            text: 'Международно признанный визажист и преподаватель, специализирующаяся на кино и театральном макияже. Елена работала над множеством кинопроектов и получила ряд наград за лучший грим и спецэффекты в киноиндустрии. Ее вклад в обучение новых поколений визажистов неоценим.',
            image: VisagisteImg_2,
            name1: 'Александра Белова (Беларусь)',
            name2: 'Татьяна Лысенко (Украина)',
            name3: 'Алия Нуртаева (Казахстан)',
        },
          {
            title: 'Прорыв Года',
            name: 'Андрей Чернышов (Председатель жюри)',
            text: 'Основатель технологического стартапа, который разработал новое устройство для неинвазивной коррекции кожи. Его продукты помогают значительно улучшить качество ухода за кожей и доступны для широкого круга потребителей.',
            image: YearImg_2,
            name1: 'Лилия Федорова (Беларусь)',
            name2: 'Олег Петров (Украина)',
            name3: 'Кристина Алексеева (Казахстан)',
          },
          {
            title: 'Мастер года в Перманентном Макияже',
            name: 'Виктория Марчук (Председатель жюри)',
            text: 'Визажист, мастер по прическам Международного класса, Многократный чемпион, призер российских и международных соревнований по макияжу, боди-арту, Визажист недели моды в Париже, участник и организатор международных проектов, Официальный визажист, член жюри конкурсов Мисс, Миссис Псков, Владелица собственной студии макияжа, организатор многочисленных мастер-классов по макияжу и прическам, преподаватель и автор программ обучения.',
            image: MakeUpImg_2,
            name1: 'Максим Самохин (Беларусь)',
            name2: 'Екатерина Иванова (Украина)',
            name3: 'Лариса Шусть (Казахстан)',
          },
          {
            title: 'Парикмахер Года',
            name: 'Лера Степанова (Председатель жюри)',
            text: 'Эксперт по продвижению и развитию мастеров и тренеров в бьюти-сфер, Наставник по продажам в блоге, Организатор интенсива «ЯРКИЙ СЕРИАЛ В СТОРИС», Топ бизнес-тренер по Нижегородской области, Победитель чемпионата MARICH по моделированию бровей в России, Рекордсмен книги рекордов России, Призер международного чемпионата BRILLIANCE, Обладательница премий: ЛЕГЕНДА БЬЮТИ 2023, НАСТАВНИК НА МИЛЛИОН 2023 и других.',
            image: BarberImg_2,
            name1: 'Анжела Рубцова (Беларусь)',
            name2: 'Никита Адамов (Украина)',
            name3: 'Яна Козлова (Казахстан)',
          },
          {
            title: 'За Вклад в Развитие Индустрии',
            name: 'Анатолий Чернов (Председатель жюри)',
            text: 'Лидер в области создания экологически безопасных косметических средств. Анатолий имеет множество публикаций и патентов, которые оказали значительное влияние на отрасль, делая производство более чистым и эффективным.',
            image: GrowthImg_2,
            name1: 'Елена Борисова (Беларусь)',
            name2: 'Сергей Ткаченко (Украина)',
            name3: 'Марина Алексеева (Казахстан)',
          },

        ],
      },
      {
        year: 2021,
        items: [
        {
            title: 'Инноватор Года',
            name: 'Иван Петров (Председатель жюри)',
            text: 'Признанный эксперт в области нанотехнологий, применяемых в косметической индустрии. Иван обладает глубокими знаниями в создании и внедрении новых материалов, которые значительно повышают эффективность косметических продуктов. Его работа помогла революционизировать многие аспекты кожного ухода, делая процедуры более безопасными и доступными. Иван является автором ряда научных публикаций и патентов, которые легли в основу современных косметических технологий. Его способность интегрировать научные достижения в практические решения делает его ценным членом жюри для оценки инновационных достижений в номинации "Инноватор Года".',
            image: InivatorImg_3,
            name1: 'Лариса Казакова (Беларусь)',
            name2: 'Виктория Нечаева (Украина)',
            name3: 'Евгений Миронов (Казахстан)',
          },
          {
            title: 'Лучший Мастер Эстетической Медицины',
            name: 'Алина Никодимова (Председатель жюри)',
            text: 'Косметолог, двукратный победитель II Всероссийского конкурса по эстетической косметологии и массажу Ethics, врач с опытом работы в центрах реабилитации неврологических больных, преподаватель базовых курсов по косметологии и авторских методик по массажу лица, специалист и преподаватель в области эстетического кинезиотейпирования лица и тела. Стаж работы более 5 лет',
            image: MedicImg_3,
            name1: 'Ирина Козлова (Украина)',
            name2: 'Наталия Козлова (Россия)',
            name3: 'Владислав Мельник (Беларусь)',
          },
          {
            title: 'Мастер года в Ногтевой Эстетике',
            name: 'Инна Лантратова (Председатель жюри)',
            text: 'Директор компании «KorNail», Председатель и главный тренер по компетенции ногтевой сервис "Абилимпикс", Тренер Национальной сборной "Абилимпикс", Тренер сборной команды Expert Centre, Победитель и призёр российских и международных конкурсов, Организатор чемпионатов Nail Bridge и Nail Battle, Судья российских и международных конкурсов.',
            image: MasterImg_3,
            name1: 'Екатерина Казанцева (Россия)',
            name2: 'Наталия Мизенцева (Украина)',
            name3: 'Олеся Михайлова (Казахстан)',
          },
          {
            title: 'Визажист Года',
            name: 'Сергей Воронов (Председатель жюри)',
            text: 'Знаменитый визажист и арт-директор, сотрудничающий с мировыми домами моды. Сергей известен своими инновационными подходами и созданием трендов в макияже для подиумов и фотосессий. Он регулярно проводит мастер-классы и семинары, делясь опытом с профессионалами по всему миру.',
            image: VisagisteImg_3,
            name1: 'Марина Ковалева (Беларусь)',
            name2: 'Анна Грищенко (Украина)',
            name3: 'Касымов (Казахстан)',
        },
          {
            title: 'Прорыв Года',
            name: 'Мария Лебедева (Председатель жюри)',
            text: 'Эксперт в области новых материалов для косметики. Мария привнесла множество инновационных решений, которые сделали косметические продукты более безопасными и эффективными. Она активно работает с международными лабораториями для разработки и тестирования новых составов.',
            image: YearImg_3,
            name1: 'Виктор Соболев (Беларусь)',
            name2: 'Тамара Гончарова (Украина)',
            name3: 'Надежда Смирнова (Казахстан)',
          },
          {
            title: 'Мастер года в Перманентном Макияже',
            name: 'Александра Корсак (Председатель жюри)',
            text: 'Владелец собственной студии по оформлению бровей KORSAK.BROWS, Эксперт Бренда Lerato.cosmetic, flario, Амбассадор Бренда lenalevi.cosmetics, Чемпион и призер чемпионатов "Silvi_star_champ по ламинированию бровей", Лауреат премии TOP 10 BROWS EXPERT 2022 при поддержки министерства образования, Участник 4,5,6 сезона ebeishiy.beauty.Marafon, Призер в 5 сезоне от Насти Клюквы.',
            image: MakeUpImg_3,
            name1: 'Светлана Королева (Беларусь)',
            name2: 'Тамара Алексеева (Украина)',
            name3: 'Лариса Шусть (Казахстан)',
          },
          {
            title: 'Парикмахер Года',
            name: 'Алена Соболева (Председатель жюри)',
            text: 'Номинант премий Топ-50 мастеров перманентного макияжа премии DORE2020, TOP-100SOCHI permanent Make up award 2022, Участник чемпионата VIVO business award в сфере lash 2020, Номинант премии PROFI PERFORMANCE AWARD IV 2020, Владелица успешной студии красоты, Эксперт-судья международных чемпионатов в сфере lash, Тренер Российской Академии перманентного макияжа 2022, Владелица бьюти школы наращивания ресниц и перманентного макияжа с 2022',
            image: BarberImg_3,
            name1: 'Анжела Рубцова (Беларусь)',
            name2: 'Юрий Николаев (Украина)',
            name3: 'Надежда Соколова (Казахстан)',
          },
          {
            title: 'За Вклад в Развитие Индустрии',
            name: 'Татьяна Романенко (Председатель жюри)',
            text: 'Профессор, ведущий научные исследования в области биотехнологий, способствующих развитию косметической отрасли. Татьяна занимается созданием инновационных продуктов, которые улучшают качество жизни потребителей и снижают воздействие на окружающую среду.',
            image: GrowthImg_3,
            name1: 'Игорь Сидоров (Беларусь)',
            name2: 'Люда Василенко (Украина)',
            name3: 'Денис Кириллов (Казахстан)',
          },

        ],
      },
      {
        year: 2020,
        items: [
          {
            title: 'Инноватор Года',
            name: 'Елена Белова (Председатель жюри)',
            text: 'Выдающийся ученый в области дерматологии и косметологии, Елена известна своими работами по разработке новых косметических продуктов, которые сочетают в себе последние научные достижения и требования экологической безопасности. Она принимала участие в создании нескольких революционных формул, которые сегодня используются ведущими мировыми брендами. Елена обладает уникальной способностью видеть потенциал в новых технологиях и методиках, что делает её незаменимым членом жюри в номинации "Инноватор Года".',
            image: InivatorImg_4,
            name1: 'Михаил Королев (Беларусь)',
            name2: 'Анна Соколова (Украина)',
            name3: 'Даниил Павлов (Казахстан)',
          },
          {
            title: 'Лучший Мастер Эстетической Медицины',
            name: 'Ольга Пономарёва (Председатель жюри)',
            text: 'Косметолог, массажист, физиотерапевт аппаратной косметологии. Методист-косметолог производителя профессиональной косметики. Фельдшер Территориального центра Медицины катастроф. Преподаватель в медицинском колледже, а также авторских программ по косметологии, эстетических массажей, тейпирования. Стаж работы в косметологии 11 лет.',
            image: MedicImg_4,
            name1: 'Ольга Павлова (Казахстан)',
            name2: 'Алиса Сергеева (Россия',
            name3: 'Яна Кирсанова (Украина)',
          },
          {
            title: 'Мастер года в Ногтевой Эстетике',
            name: 'Инга Аванесян (Председатель жюри)',
            text: 'Выдающийся мастер маникюра с 10-летним стажем, известная своими уникальными техниками и инновационным подходом к дизайну ногтей. Инга внесла значительный вклад в популяризацию экологичных материалов и методов в ногтевом сервисе. Обладатель Патента на полезную модель «Способ моделирования формы «Стилет» искусственного ногтя» Победитель Международного конкурса «Звезды Красоты» 2020. Обладатель Международной премии «Олимп Красоты» 2019. ',
            image: MasterImg_4,
            name1: 'Екатерина Казанцева (Россия)',
            name2: 'Мария Воронцова (Украина)',
            name3: 'Анна Жукова (Казахстан)',
          },
          {
            title: 'Визажист Года',
            name: 'Лидия Михайлова (Председатель жюри)',
            text: 'Ведущий эксперт в области профессионального макияжа с более чем 20-летним опытом. Лидия является основателем школы макияжа «ArtMakeup Pro», где обучает молодых специалистов современным техникам и инновациям в индустрии красоты. Ее работы украшают обложки ведущих модных журналов, а вклад в развитие профессионального визажа признан на международном уровне.',
            image: VisagisteImg_4,
            name1: 'Виктория Сидоренко (Беларусь)',
            name2: 'Олег Гриценко (Украина)',
            name3: 'Гульмира Сатыбалдиева (Казахстан)',
        },
          {
            title: 'Прорыв Года',
            name: 'Ирина Волкова (Председатель жюри)',
            text: 'Ведущий специалист в области молодежных инноваций в косметологии. Ирина известна своей способностью выявлять и поддерживать молодые таланты в индустрии. Она организовала множество стартап-инкубаторов, которые помогли молодым предпринимателям воплотить их идеи в жизнь и внедрить их на международный рынок.',
            image: YearImg_4,
            name1: 'Алексей Морозов (Беларусь)',
            name2: 'Светлана Кучеренко (Украина)',
            name3: 'Егор Тимофеев (Казахстан) ',
          },
          {
            title: 'Мастер года в Перманентном Макияже',
            name: 'Дарья Махиня (Председатель жюри)',
            text: 'мастер с исключительным талантом и глубокими знаниями в области эстетической коррекции и перманентного макияжа. Она активно внедряет передовые технологии и материалы, обеспечивая высокую степень удовлетворенности клиентов. Победитель Международного конкурса «Звезды Красоты» 2020. Обладатель Международной премии «Олимп Красоты» 2019. Спикер на Международных конференциях. ',
            image: MakeUpImg_4,
            name1: 'Светлана Королева (Беларусь)',
            name2: 'Ольга Захарова (Украина)',
            name3: 'Яна Петрова (Казахстан)',
          },
          {
            title: 'Парикмахер Года',
            name: 'Екатерина Дементьева (Председатель жюри)',
            text: 'Обучение парикмахерскому искусству в Соединенных Штатах Америки, Победитель и призер региональных и международных чемпионатов, 2015 год - вошла в пятерку лучших мастеров Европы, Чемпионат Европы FESTIVAL INTERNAZIONALE de la COIFFURE e dell ESTETICA (Италия), Организатор семинаров, мастер-классов, курсов повышения квалификации, Сооснователь салона красоты «Честно к себе».',
            image: BarberImg_4,
            name1: 'Анна Жукова (Беларусь)',
            name2: 'Наталья Королева (Украина)',
            name3: 'Надежда Соколова (Казахстан)',
          },
          {
            title: 'За Вклад в Развитие Индустрии',
            name: 'Николай Васильев (Председатель жюри)',
            text: 'Ведущий специалист в интеграции устойчивых технологий в косметическую индустрию. Николай активно участвует в разработке стандартов экологичного производства и является консультантом для крупных международных организаций по вопросам устойчивости. Его вклад в развитие отрасли и продвижение экологически чистых технологий неоценим.',
            image: GrowthImg_4,
            name1: 'Виктория Козлова (Беларусь)',
            name2: 'Олег Дубровин (Украина)',
            name3: 'Галина Еремина (Казахстан)',
          },

        ],
      },
  ];

  export default data;
